// Token d'invitation EN ATTENTE (deep-link). Survit à l'authentification pour
// pouvoir afficher l'écran de confirmation puis accepter, quel que soit le mode
// d'auth (natif OTP — pas de reload — ou Entra redirect).
//
// Web uniquement (les invitations arrivent par email -> navigateur). Sur natif,
// le token vient des params de route (deep link ccjaw://invite/:token).
import { Platform } from 'react-native';

const KEY = 'ccjaw.pendingInvite';

// Rejette les jetons vides / placeholders ('undefined'/'null' qui peuvent
// apparaître si un composant réécrit l'URL sans param).
function clean(tok: string | null | undefined): string | null {
  const t = (tok ?? '').trim();
  if (!t || t === 'undefined' || t === 'null') return null;
  return t;
}

/** Extrait le token de l'URL : ``/invite/<token>`` (nouveau) ou ``?invite=<token>`` (ancien). */
export function inviteTokenFromUrl(): string | null {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return null;
  try {
    const u = new URL(window.location.href);
    const q = clean(u.searchParams.get('invite'));
    if (q) return q;
    const m = u.pathname.match(/^\/invite\/([^/]+)\/?$/i);
    if (m) return clean(decodeURIComponent(m[1]));
  } catch { /* ignore */ }
  return null;
}

export function setPendingInvite(token: string): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  const t = clean(token);
  if (!t) return; // n'écrase jamais un bon token avec un placeholder
  try { window.sessionStorage.setItem(KEY, t); } catch { /* ignore */ }
}

/** Token en attente : storage (mémorisé) sinon l'URL courante. */
export function getPendingInvite(): string | null {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return null;
  try { return clean(window.sessionStorage.getItem(KEY)) || inviteTokenFromUrl(); }
  catch { return inviteTokenFromUrl(); }
}

/** Capture le token de l'URL dans le storage (idempotent). Retourne le token. */
export function captureInvite(): string | null {
  const t = inviteTokenFromUrl();
  if (t) setPendingInvite(t);
  return t || getPendingInvite();
}

export function clearPendingInvite(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  try { window.sessionStorage.removeItem(KEY); } catch { /* ignore */ }
  // Nettoie l'URL pour ne pas re-déclencher au prochain rendu.
  try {
    if (/\/invite\//i.test(window.location.pathname) || window.location.search.includes('invite=')) {
      window.history.replaceState({}, '', '/');
    }
  } catch { /* ignore */ }
}
